import { render, staticRenderFns } from "./EmailInner.vue?vue&type=template&id=af025aa2&scoped=true&"
import script from "./EmailInner.vue?vue&type=script&lang=js&"
export * from "./EmailInner.vue?vue&type=script&lang=js&"
import style0 from "./EmailInner.vue?vue&type=style&index=0&id=af025aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af025aa2",
  null
  
)

export default component.exports